'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _zarm = require('zarm');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// 获取屏幕高度
var getViewHeight = function getViewHeight() {
  // server side
  if (typeof window === 'undefined') {
    return {
      maxHeight: 0
    };
  }

  var height = (window.innerHeight || document.documentElement.clientHeight) * 0.9 - 60;

  return {
    height: height
  };
};

var timer = null;

var AddressBook = function (_PureComponent) {
  _inherits(AddressBook, _PureComponent);

  function AddressBook() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddressBook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddressBook.__proto__ || Object.getPrototypeOf(AddressBook)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      style: getViewHeight(),
      isFocus: false,
      value: '',
      searchData: []
    }, _this.onFocus = function () {
      _this.setState({ isFocus: true });
    }, _this.onChange = function (value) {
      var dataSource = _this.props.dataSource;


      _this.setState({ value: value });

      timer && clearTimeout(timer);
      timer = setTimeout(function () {
        var searchData = dataSource.filter(function (item) {
          return item.name.indexOf(value) >= 0;
        });

        _this.setState({
          searchData: searchData
        });
      }, 500);
    }, _this.onCancel = function () {
      _this.setState({
        isFocus: false,
        value: '',
        searchData: []
      });
    }, _this.onChangeItem = function (item) {
      var onChange = _this.props.onChange;


      onChange && onChange(item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddressBook, [{
    key: 'renderSearch',
    value: function renderSearch() {
      var _this2 = this;

      var prefixCls = this.props.prefixCls;
      var _state = this.state,
          value = _state.value,
          isFocus = _state.isFocus;

      var cls = (0, _classnames2.default)(prefixCls + '-search', _defineProperty({}, prefixCls + '-search-focus', isFocus));

      return _react2.default.createElement(
        'div',
        { className: cls },
        _react2.default.createElement(
          'div',
          { className: prefixCls + '-search-inner' },
          _react2.default.createElement(_icon2.default, { type: 'sousuo' }),
          _react2.default.createElement(_zarm.Input, {
            placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D',
            className: 'input-search',
            value: value,
            onFocus: function onFocus() {
              return _this2.onFocus();
            },
            onChange: function onChange(v) {
              return _this2.onChange(v);
            }
          }),
          _react2.default.createElement(
            _zarm.Button,
            {
              shape: 'round',
              theme: 'primary',
              className: 'button-search'
            },
            '\u641C\u7D22'
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'button-cancel',
            onClick: function onClick() {
              return _this2.onCancel();
            }
          },
          '\u53D6\u6D88'
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody(data) {
      var _this3 = this;

      var _state2 = this.state,
          style = _state2.style,
          isFocus = _state2.isFocus,
          value = _state2.value,
          searchData = _state2.searchData;
      var prefixCls = this.props.prefixCls;

      var showData = isFocus && value.length ? searchData : data;

      var notNode = function notNode() {
        var text = isFocus ? '没有匹配的结果' : '没有客户';
        return _react2.default.createElement(
          'div',
          { className: 'not-list' },
          text
        );
      };

      var itemNode = function itemNode() {
        return _react2.default.createElement(
          'div',
          { className: prefixCls + '-list' },
          _react2.default.createElement(
            'div',
            { className: prefixCls + '-sub-title' },
            'A'
          ),
          showData.map(function (item, key) {
            return _react2.default.createElement(
              'div',
              {
                className: prefixCls + '-item',
                key: 'item_' + key,
                onClick: function onClick() {
                  return _this3.onChangeItem(item);
                }
              },
              _react2.default.createElement(
                'div',
                { className: 'item-name' },
                item.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'item-content' },
                '\u8EAB\u4EFD\u8BC1',
                item.certiType,
                '  ',
                item.certiNo
              )
            );
          })
        );
      };

      return _react2.default.createElement(
        'div',
        {
          className: prefixCls + '-body',
          style: style
        },
        Array.isArray(showData) && showData.length ? itemNode() : notNode()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          visible = _props.visible,
          className = _props.className,
          dataSource = _props.dataSource;


      var cls = (0, _classnames2.default)(prefixCls, _defineProperty({}, className, !!className));

      return _react2.default.createElement(
        _zarm.Popup,
        {
          visible: visible,
          className: cls
        },
        this.renderSearch(),
        this.renderBody(dataSource)
      );
    }
  }]);

  return AddressBook;
}(_react.PureComponent);

AddressBook.propTypes = {
  prefixCls: _propTypes2.default.string,
  className: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  dataSource: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onChange: _propTypes2.default.func
};
AddressBook.defaultProps = {
  prefixCls: 'cui-address-book',
  className: '',
  visible: true,
  dataSource: [],
  onChange: function onChange() {}
};
exports.default = AddressBook;